export const baseQualificationCredential = {
  verification: {
    result: 'Engineering Certificate II',
  },
  credentialInfo: [
    {
      name: 'Education Provider',
      values: ['Monash College'],
    },
    {
      name: 'Finished',
      values: ['2000'],
    },
    {
      name: 'Full name',
      values: ['John Doe'],
    },
    {
      name: 'Verified on',
      values: ['4 May 2021'],
    },
  ],
  deleteVerificationUrl:
    'https://certsy.com/data-sharing?utm_source=seek&utm_medium=referral&utm_campaign=profile-delete&utm_content=education-qualifications',
  manageVerificationUrl:
    'https://certsy.com/career-passport/education-qualifications?utm_source=seek&utm_medium=referral&utm_campaign=profile-manage&utm_content=education-qualifications',
};
